export const ApplePayPreview = ({data}) => {
    return (
        <div
            className='apple-pay-block-editor'
            style={{maxHeight: '40px', backgroundColor: '#000', borderRadius: '4px'}}>
            <img
                src={data.editorIcon}
                style={{width: '100%', height: '40px', objectFit: 'contain'}}/>
        </div>
    )
}

export default ApplePayPreview;